import { get, IHttpRequestConfig } from "@/browser";
import { extractDataFromResponse } from "@/core/api";
import { compose } from "@/core/url";

import { ISuggestedProfileData, suggestedProfileDataType } from "./types";

const API = {
  fetchSuggested: "/api/suggested-profile-data",
};

export interface IFetchSuggestedProfileDataParams {
  cvIds?: number[];
}

export const fetchSuggestedProfileData = (params?: IFetchSuggestedProfileDataParams, options?: IHttpRequestConfig) => {
  const url = compose(API.fetchSuggested, {}, params);
  return get<ISuggestedProfileData>(url, options).then(extractDataFromResponse).then(suggestedProfileDataType);
};
